import React from 'react'
import { toPlainText } from 'src/utils/utils'

export interface SchemaProps {
  pagePath: string
  title: string
  publishedAt: any
  updatedAt: any
  image: {
    asset: {
      url: string
    }
  }
  editorialText: any[]
}

export const generateSchema = ({
  pagePath,
  title,
  publishedAt,
  updatedAt,
  image,
  editorialText,
}: SchemaProps) => {
  const schema = {
    '@context': 'http://schema.org/',
    '@type': 'Article',
    author: {
      '@type': 'Organization',
      name: 'Tia',
    },
    headline: title,
    datePublished: publishedAt,
    dateModified: updatedAt,
    url: pagePath,
    image: image.asset.url,
    articleBody: toPlainText(editorialText),
    publisher: {
      '@type': 'Organization',
      name: 'Tia',
      logo: {
        '@type': 'ImageObject',
        url: 'https://www.asktia.com/static/tia-logo.png',
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': pagePath,
    },
  }

  return schema
}
